import React from 'react';
import { Button, message } from 'antd';
import { FcGoogle } from 'react-icons/fc';
import axios from 'axios';
import { auth, provider, signInWithPopup } from '../../config/firebase';

export default function GoogleSignInButton({ setUser, navigate }) {
  const handleClick = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      const { data, headers } = await axios.post(
        '/google/login',
        { idToken, keep_session: true },
        { withCredentials: true }
      )

      if(data.link_pending){
        navigate('/link', {
          state: {
            email:      data.email,
            google_id:  data.google_id
          }
        })
        return
      }

      sessionStorage.setItem('token', headers.authorization)
      sessionStorage.setItem('user', JSON.stringify(data.user));
      axios.defaults.headers.common['Authorization'] = headers.authorization

      setUser(data.user)
      navigate(
        data.user.cliente_id
          ? '/customer/dashboard'
          : '/admin/dashboard'
      )
    } catch (err) {
      if (err.code === 'auth/popup-closed-by-user') {
        message.info('Has cancelado el inicio de sesión.');
        return;
      }
      message.error(err.response?.data?.message || err.message)
    }
  }

  return (
    <Button
      icon={<FcGoogle style={{ fontSize: 20, marginRight: 8 }} />}
      block
      size="large"
      onClick={handleClick}
    >
      Continue with Google
    </Button>
  );
}
